export default "__VITE_ASSET__BH34zj$n__ 640w, __VITE_ASSET__DUTOOzM2__ 1024w, __VITE_ASSET__UU69bTND__ 1280w";